"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = MissingFieldsModal;

var _react = _interopRequireDefault(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _isValidBrief = require("../../../utils/isValidBrief");

require("../styles/_missing-fields-modal.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var HELP_URL = 'https://intercom.help/shootstahub/en/articles/3503927-how-to-brief-a-video-project-for-editing';

function FieldBlock(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      visible = _ref.visible,
      onClose = _ref.onClose,
      stage = _ref.stage,
      history = _ref.history;

  if (!visible) {
    return null;
  }

  var onUpdate = function onUpdate() {
    onClose();
    history.push("#".concat(stage));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "missing-fields-modal__fields__field"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "missing-fields-modal__fields__field__text"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    button: true
  }, title), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    noMargin: "bottom"
  }, subtitle)), /*#__PURE__*/_react.default.createElement(_uiKit.Button, {
    onClick: onUpdate
  }, "Update"));
}

function MissingFieldsModal(_ref2) {
  var clips = _ref2.clips,
      notesToTheEditor = _ref2.notesToTheEditor,
      onClose = _ref2.onClose,
      visible = _ref2.visible,
      history = _ref2.history;
  var hasClips = clips && clips.length;
  var hasNotes = (0, _isValidBrief.hasValidNotes)(notesToTheEditor);
  return /*#__PURE__*/_react.default.createElement(_uiKit.FormModal, {
    visible: visible,
    onClose: onClose,
    hideFooter: true,
    title: "You're Almost There"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "missing-fields-modal"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    noMargin: "top"
  }, "Please fill out the missing fields so our Video Editors have all the relevant project information on hand."), /*#__PURE__*/_react.default.createElement("div", {
    className: "missing-fields-modal__fields"
  }, /*#__PURE__*/_react.default.createElement(FieldBlock, {
    visible: !hasClips,
    title: "Upload Assets",
    subtitle: "Upload at least one asset",
    onClose: onClose,
    stage: 1,
    history: history
  }), /*#__PURE__*/_react.default.createElement(FieldBlock, {
    visible: !hasNotes,
    title: "Brief the Editor",
    subtitle: "Tell us more about your project",
    onClose: onClose,
    stage: 2,
    history: history
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "missing-fields-modal__footer"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    label: true,
    noMargin: "bottom"
  }, "Need help? Read our "), /*#__PURE__*/_react.default.createElement("a", {
    target: "_blank",
    rel: "noopener noreferrer",
    href: HELP_URL,
    className: "text text--link"
  }, "How to Brief A Video Project"), /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    label: true,
    noMargin: "bottom"
  }, " article for more info."))));
}